const DeliveryAddress = ({ orderPayload, orderResponse }) => {
    return (
        <div className="section">
            <h6 style={{ fontWeight: "bold" }}>DELIVERY ADDRESS</h6>

            <p style={{ color: "#625E55" }}>
                {orderPayload?.billing_first_name}{" "}
                {orderPayload?.billing_last_name}
                <br />
                {orderPayload?.billing_mobile}
                <br />
                {orderPayload?.billing_address}
                <br />
                {orderPayload?.billing_address2},
                {orderPayload?.billing_landmark},
                {orderPayload?.billing_pincode},
                {orderPayload?.billing_city},
                {orderPayload?.billing_state}
            </p>

            {orderResponse?.data?.business_details && (
                <p style={{ color: "#625E55" }}>
                    Company Name :
                    {orderResponse?.data?.business_details?.company_name}
                    <br />
                    GSTIN :
                    {orderResponse?.data?.business_details?.gst_number}
                </p>
            )}
        </div>
    );
};

export default DeliveryAddress;
